import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { mainGridGapColor } from '#/colors';

import noop from '#/utils/noop';

import { TradingViewWidget, createWidget } from './charting';

interface Props {
  readonly className?: string;
  readonly symbol?: string;
}

export default function TradingView(props: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const widget = useRef<TradingViewWidget | null>(null);

  useEffect(() => {
    if (props.symbol == null) return;
    if (containerRef.current == null) return;
    if (IS_RUNNING_IN_CYPRESS === 'true') return;

    if (widget.current == null) {
      widget.current = createWidget({
        symbol: props.symbol,
        container: containerRef.current,
      });
      return;
    }

    setSymbol(widget.current, props.symbol);
  }, [props.symbol]);

  return <Container ref={containerRef} className={props.className} />;
}

function setSymbol(widget: TradingViewWidget, symbol: string) {
  widget.onChartReady(() => {
    const activeChart = widget.activeChart();
    const activeSymbol = activeChart.symbol();

    if (`PARADEX:${symbol}` === activeSymbol) return;

    const activeResolution = activeChart.resolution();
    widget.setSymbol(symbol, activeResolution, noop);
  });
}

const Container = styled.div`
  border-bottom: 1px solid ${mainGridGapColor};
`;
